import { useAppSelector } from 'application/providers/StoreProvider';

import { useAccountSelectors } from './useAccountSelectors';

export const useAccountCompanyVideoDemoPeriod = () => {
  const selectors = useAccountSelectors();

  return useAppSelector(selectors.selectCompanyVideoDemoPeriod);
};
